import React, { useState } from "react";

const TermAndConditions = () => {
  const [definition, setDefinition] = useState([
    {
      point:
        "Farmer’s City :- online platform developed by Farmers City International Private Limited for the purchasing and selling of agricultural products and providing agricultural training and upskilling services and agricultural products transportation services, in a wide variety of formats, prices and locations.",
    },
    {
      point:
        "Account  :- profile to be created by the User to have free access and use of the Farmer’s City.",
    },
    {
      point:
        "Customer(s)  :- any professional(s) who use the Farmer’s City platform to purchase agricultural products or request the provision of Services to a Seller or a Services Provider registered in the Farmer’s City platform.",
    },
    {
      point:
        "User :- any professional(s) who use the Farmer’s City platform to purchase agricultural products, to sell, to provide or to request the provision of Services to any professional registered in the Farmer’s City platform.",
    },
    {
      point:
        "Request  :- intention to request or requesting by the Customer of (i) the product that he/she intends to purchase and / or (ii) the Service that he/she intends to be provided by the Seller / Services Provider registered in the Farmer’s City platform.",
    },
    {
      point:
        "Services Provider(s) :- legal person(s) registered in the Farmer’s City platform to provide logistics and agricultural products, transportation services and / or training services to the User(s), at his/her(their) request.",
    },
    {
      point:
        "Professional :- legal person, Customer, Seller or Services Provider, registered in the Farmer’s City platform, who intends, by this way, to purchase, to sell, to provide services or to request the provision of services.",
    },
    {
      point:
        "Service(s) :- logistics and agricultural products transportation services and / or quality / quality certification services.",
    },
    {
      point:
        "Seller(s) :- legal person(s) registered in the Farmer’s City platform to sell agricultural products to User(s), at his/her (their) request.",
    },
  ]);
  const [license, setLicense] = useState([
    {
      point:
        "Subject to acceptance by the User of these Terms and Conditions, Farmer’s City offers the User a limited, non-exclusive, non-sublicensable, revocable and non- transferable license to: (a) commercial use; (b) access to the platform on his/her personal equipment, solely for the purpose of using the platform services; and (c) access to and use any content, information and related materials that may be made available through the services of the Farmer’s City platform. Any rights not expressly granted in these terms are reserved to Farmers City International Private Limited.",
    },
    {
      point:
        "All rights on the Farmer’s City platform are and remain the property of Farmer’s City or its licensors. Neither these Terms and Conditions, nor the use of the services of the Farmer’s City platform, gives the User any rights: (a) on or related to the services, except for the limited license granted above; or (b) to use or, in any way, to refer to the company names of Farmers City, its affiliates or, where applicable, its licensors, its logos, product and service names, trademarks or other distinctive elements of Farmers City ownership.",
    },
    {
      point:
        "The User is not authorized: (a) to remove any indication of intellectual property, including, without limitation, any trademark or other notices related to the intellectual property of any space of the services of the Farmer’s City platform; b) to reproduce, modify, perform derivative works, destroy, license, rent, sell, resell, transfer, display or publicly perform, transmit, reproduce, broadcast, or otherwise exploit the services of the Farmer’s City platform, except to the extent expressly permitted by Farmers City International; (c) to decompile, reverse engineer or disassemble the Farmer’s City platform, except to the extent permitted by applicable law; (d) to create links or frame any part of the Farmer’s City platform; (e) to create or launch any programs or scripts to capture, index, collect or otherwise extract data from any part of the Farmer’s City platform, or unduly overloading and / or preventing the operation and /or functionality of the Farmer’s City platform ; or (f) to attempt to get unauthorized access to the Farmer’s City platform or impair any aspect of the Farmer’s City platform or its systems or networks.",
    },
  ]);
  const [access, setAccess] = useState([
    {
      point:
        "To access the services of the Farmer’s City platform, in addition to the acceptance of these Terms and Conditions, it is necessary to create an Account.",
    },
    {
      point: "The User must be at least 18 years of age to obtain an Account.",
    },
    {
      point:
        "The process of creating an Account requires the User to fill in certain personal information such as name, address, mobile phone number, email address, payment details, company data, among others.",
    },
    {
      point:
        "Payment data shall be validated by Farmer’s City back office and its Payment Service Provider Partner, within a 24-48 hours period. After this validation and approval, the User may use the Farmer’s City platform.",
    },
    {
      point:
        "The Farmer’s City platform only allows one Account per User, unless expressly provided otherwise.",
    },
    {
      point:
        "The User guarantees the accuracy, completeness and timeliness of the information that he/she submits. If the information submitted proves to be false, incomplete, or outdated, Farmer’s City may disable the User's access to the Farmer’s City platform.",
    },
    {
      point:
        "The User is responsible for all activity in his/her Account and undertakes to always keep the security and confidentiality of his/her User name and password.",
    },
    {
      point:
        "The User undertakes to immediately notify Farmer’s City if he/she becomes aware of an unauthorized use or any other breach of security relating to his/her Account.",
    },
    {
      point:
        "The User agrees that all activities that occur through his/her Account (including but not limited to posting any information about the Professional and / or the Product and / or the Service, clicking to accept any additional terms or rules, subscribing or making any payment for any service or purchase of products, etc.) shall be considered as authorized by the User.",
    },
    {
      point: `The User agree that all activities that occur through the Account (including, without limitation, any information about the Professional and / or the product and / or Service, click to accept any additional terms or rules, to subscribe or make any
        Payment. For any service or purchase of products, among others will be considered as authorized by the User.
        `,
    },
    {
      point: `With the creation of the Account, the User is entitled to access the network provided by the Farmer’s City platform, according to these Terms and Conditions.`,
    },
  ]);
  const [how, setHow] = useState([
    {
      point:
        "The Farmer’s City platform allows: (a) the placement of information regarding the sale and / or provision of Services; (b) to make orders for purchase and / or provision of Services to the Sellers and / or Services Providers; and (c) intermediation by Farmer’s City of any payments to be made by the Customer to the Sellers and / or Services Providers, against the payment of a commission to Farmer’s City. This commission shall be paid to Farmer’s City by the Customers and by the Sellers and / or Services Providers.",
    },
    {
      point: `Through the Farmer’s City platform, the Sellers and / or Services Providers may
      (i) place any information on the selling of agricultural products and / or the provision of Services, and / or (ii) release on Farmer’s City their intention to sell agricultural products and / or to provide Services.
      `,
    },
    {
      point: `In turn, the Customer may: (i) launch in the Farmer’s City platform his/her intention to request the purchase of agricultural products and / or the provision of Services, and / or (ii) request the provision of Services and / or the purchase of agricultural products to the Sellers and / or Services Providers registered therein. To this end, the Customer shall indicate in the Farmer’s City platform any data requested, namely the product that he/she intends to purchase and / or the Service to be provided, the price, location and intended date for delivery and / or provision of the Service.`,
    },
    {
      point:
        "Payment data shall be validated by Farmer’s City back office and its Payment Service Provider Partner, within a 24-48 hours period. After this validation and approval, the User may use the Farmer’s City platform.",
    },
    {
      point: `The intention of the Seller/ Services Provider or Customer to request, respectively, the sale or purchase of agricultural products and / or the provision of Services set forth in paragraph 2 (ii) and 3 (i) shall be valid for the period indicated upon the launch of intention to sell / purchase or until such time that the sale and / or provision of Services takes place or the Seller / Services Provider or Customer withdraw their intent to sell or request.`,
    },
    {
      point: `In the case referred to in the preceding paragraph, the Seller and / or Services Provider and the Customer interested in the sale or purchase and / or provision of Services shall respond to the request of the Seller/ Services Provider or Customer, and the provisions of paragraphs 7 and 8, below, shall apply.`,
    },
    {
      point: `In the event that the Customer places the request referred to in paragraph 3 (ii) Service and / or purchase of agricultural product order, the Seller shall confirm, within 72 hours, the receipt of the order and inform the Customer of the estimated time for delivery, and / or the Services Provider shall confirm, within 72 hours, the provision of the service and the estimated time for the beginning of the provision of the Service.`,
    },
    {
      point: `Upon receipt of the confirmation and the estimated time for delivery of the product and / or for the beginning of the provision of the Services, the Customer decides whether to accept the order and / or the service under the proposed conditions; in which case the Customer shall select the option to proceed with the payment in the Farmer’s City platform.`,
    },
    {
      point:
        "The Seller and / or Services Provider shall receive the information of the acceptance of the order of the product and / or the service in the conditions presented, thus initiating the conclusion of the process.",
    },
  ]);
  const [condition, setCondition] = useState([
    {
      point:
        "The User agrees to comply with the rules of Farmer’s City on the publication of information and sales practices.",
    },
    {
      point: `The User is responsible for the truthfulness, accuracy, and content of the information of the product / Service provided.`,
    },
    {
      point: `The User undertakes to only sell and provide services that are lawful and in accordance with the law in force.`,
    },
    {
      point:
        "The User product / Service may not be published on the Farmer’s City platform immediately upon its submission by the User and may take up to 24 hours to be available on the Farmer’s City platform.",
    },
    {
      point: `Farmer’s City does not undertake to create a market where Customers find what they are looking for, therefore the appearance or placement in the search and browsing results list shall depend on a variety of factors, including, but not limited to:`,
      subpointA: `a. Location of the Customer, search query, navigation website and history;`,
      subpointB: `b. Location of the item or service, content format, price, terms of service, history and relevance to Customer content;`,
      subpointC: `c. History of the Seller and / or Services Provider.`,
    },
    {
      point: `The User agrees not to submit any content that is defamatory, libelous, violent, obscene, illegal, or in any way offensive, whether or not this material is protected by law.`,
    },
    {
      point: `Farmer’s City reserves the right (but shall have no obligation) to decide whether the contents meet the requirements of these Terms and Conditions and may at any time and without notice remove such content and / or terminate a User’s access to the Service for providing content that violates these Terms and Conditions.`,
    },
  ]);
  const [contracting, setContracting] = useState([
    {
      point:
        "The Customer accepts that he/she is responsible for reading any information on the product / service before making the purchase or contracting the service.",
    },
    {
      point: `The Seller and the Services Provider agree that they are responsible for reading any information on the product and / or service requested by the Customer before accepting the sale or service provision.`,
    },
    {
      point: `The Customer, the Seller and the Services Provider acknowledge that when placing an order for a product or requesting the provision of a service and accepting a product ordering or service requesting by the Customer, they are entering into a legally binding contract.`,
    },
  ]);
  const [services, setServices] = useState([
    {
      point:
        "The price due for the products / services purchased by the Customer shall be the price defined on the Farmer’s City, considering the prices indicated by the Seller / Services Provider and any other condition applicable to the purchase and sale or provision of services.",
    },
    {
      point: `The Customer shall also be responsible for the payment to Farmer’s City of an amount due for the services of the platform. This amount shall be added to the price due for the products and / or services or, if the purchase and sale or services provision results from a request of an intention to request the purchasing of agricultural products and / or provision of Services, the amount due to Farmer’s City shall be deducted from the price indicated by the Customer for this purpose.`,
    },
  ]);
  const [paymentMethod, setPaymentMethod] = useState([
    {
      point:
        "In order to be able to carry out operations on the Farmer’s City platform, the Customer shall made the payment either through Online Payment.",
    },
    {
      point: `To carry out the payment of the products and / or services ordered, the User expressly accepts the terms and conditions of use of the partner payment platform, available at farmerscity.in.`,
    },
    {
      point: `Farmer’s City shall charge (i) the price due for the products and / or Services, under the terms agreed between the Customer and the Seller and / or Services Provider, and indicated in the Farmer’s City platform, and (ii) Service Charge and/or Logistics Costs (In case of Doorstep Delivery) due to Farmer’s City for the services provided by the Farmer’s City platform according to the procedure described above.`,
    },
  ]);
  const [userObligation, setUserObligation] = useState([
    {
      point:
        "The User undertakes not to directly contract or make any direct payments to other Users of the Farmer’s City network, with whom he/she has had contacts through this network, other than through the Farmer’s City platform.",
    },
    {
      point: `The User agrees not to use services for purposes other than those for which they are intended, namely illicit purposes.`,
    },
    {
      point: `The User undertakes not to send to third parties or otherwise disclose any request existing in the Farmer’s City platform or to distribute or publicly display any content of the Farmer’s City platform without prior and express permission of Farmers City International.`,
    },
    {
      point: `The User further declares that: (a) the activities pursued through the Farmer’s City platform comply with the applicable rules, regulations and legislation in force; (b) he/she carries out commercial transactions with other Users in good faith; (c) he/she complies with the agreements concluded through the Farmer’s City platform and in the terms indicated therein; (d) he/she shall not impersonate any other person or entity or misrepresenting his/her relationship with any other entity.`,
    },
    {
      point: `Upon knowledge of any violation or potential violation of these Terms and Conditions, Farmer’s City reserves the right (but shall have no obligation) to decide whether the User meets the requirements of these Terms and Conditions and may, at any time and without prior notice, terminate any User’s access to the Farmer’s City platform.`,
    },
    {
      point: `The conditions applicable to the processing of the User’s personal data that may be collected by Farmer’s City International, directly or through the Farmer’s City platform, are best described in the Privacy Policy of Farmer’s City and its partners, available on the Privacy web page.`,
    },
    {
      point: `The User undertakes to respect the personal data submitted in the Farmer’s City platform, namely, not to proceed to its disclosure, publication or interception.`,
    },
    {
      point: `The User is responsible for obtaining the necessary access to the data network to use the services provided by the Farmer’s City platform. The fees and rates of the data and messages network of the mobile equipment of the User may apply, should the User access to or use the Services from a wireless device, and the User is responsible for paying such fees and rates. The User is responsible for acquiring and updating the equipment or devices required to access and use the services and any updates thereof. The Farmer’s City platform services may be subject to
 
      failures and / or delays inherent to the use of the Internet and electronic communications. Farmer’s City does not guarantee the operation of the Farmer’s City platform or that the Farmer’s City platform services or any part thereof will work on a particular equipment or device.`,
    },
  ]);
  const [liability, setLiability] = useState([
    {
      point:
        "Farmer’s City guarantees that it is in a legitimate and legal position to market and provide the Farmer’s City platform.",
    },
    {
      point: `There is no relationship between Farmer’s City, the Customer, the Seller and / or Services Provider other than the availability of the Farmer’s City platform, as provided in these Terms and Conditions. The Customer acknowledges that the purchase and sale of products and / or that the Services provided or rendered by the Sellers and / or Services Providers, which act on their own account and responsibility, and that Farmer’s City is not, in any way, part the contractual relationship established between the Customer, the Seller and / or Services Provider.`,
    },
    {
      point: `Farmer’s City is not responsible for the execution of the agreement between Customer and the Seller and / or Services Provider, for the proper performance of the agreement signed between them, for the fulfilment of any conditions agreed between the Customer and the Seller and / or the Services Provider or for the quality, suitability, safety, and competence of the product purchased from the Seller and / or the Service provided by the Services Provider. Farmer’s City is not therefore responsible for the payment of the services / products by the Customer, and it shall not be enforceable against the Customer the lack of funds or insufficient funds in the account indicated by the Customer to make payments to the Seller and / or Services Provider.`,
    },
    {
      point: `Similarly, Farmer’s City shall not be liable before the User and / or any third party for any direct or indirect damages, warranties, lost profits or any damages that may result from the relationship between the Customer, the Seller and / or Services Provider. The Customer accepts all risk arising from any product and / or services request.`,
    },
    {
      point: `Farmer’s City and the Users have a relationship of total technical-operational independence without obligations of exclusivity or economic dependence, and do not have a subordinate relationship with each other or any employment relationship, partnership, association, trust or any other type of relationship of a similar nature. The supply and / or the provision of the services are performed with full autonomy and independence by the Seller and / or Services Provider.`,
    },
    {
      point: `In order to meet the User’s trust and expectation, Farmer’s City verifies whether the Sellers and / or Services Providers comply with the quality standards of Farmer’s City to sell the products and provide the services made available on the Farmer’s City platform. Farmer’s City also ensures the binding of the Sellers and / or Services Providers registered in the Farmer’s City platform network to the obligation to supply the products and to perform the services with the greatest accuracy, fairness, and diligence.`,
    },
    {
      point: `Notwithstanding the foregoing, Farmer’s City is not responsible for, nor does it guarantee, the fulfilment of any requirements or conditions necessary for the provision of the services by the Services Provider or for the sale of products by the Sellers, namely, (a) compliance with the technical requirements required by law;
      (b) the existence of consent by all governing, regulatory and inspection bodies for the execution of the orders or services requested; (c) experience, knowledge and
       
      technical ability for the sale of products and / or provision of the services requested;
      (d) existence of civil liability insurance or other
      `,
    },
    {
      point: `Farmer’s City is not responsible in any way for: (a) any type of dispute, default or damage arising from the contractual relationship between the Users through the Farmer’s City platform; (b) any damage caused to third parties as a result of the supply of the products by the Seller or the execution of services by the Services Provider; (c) any damage, injury or loss arising from the use or trust created in the services provided by Farmer’s City, including any failures or interruptions in the functioning of the Farmer’s City platform and the inability to access the Farmer’s City platform; (d) any damage that may result from a malfunction of the Farmer’s City platform, either by computer failure, viruses, Trojan horses, worms or something causing interference in the system.`,
    },
    {
      point: `The information available on the Farmer’s City platform concerning the products, the Sellers, the Services Providers and the Customers is provided by the Users. Farmer’s City assumes no responsibility for any error, omission, inaccuracy or falsity of the information transmitted by the Users. Farmer’s City is in no way responsible for the information contained in the Farmer’s City platform.`,
    },
    {
      point: `10.	The Farmer’s City platform may be made available or accessible within the scope of a third-party service and content outside the control of Farmer’s City. The User acknowledges that the use of a third-party services and content may be subject to their terms of use and privacy policies. Farmer’s City provides no warranty and is not responsible for such third-party services and content. Additionally, any third-party beneficiaries of the use of the Farmer’s City platform are not part of the relationship between the User and Farmer’s City or between Users. Access to the Farmer’s City services, by the User, through a third-party equipment, services and / or content is subject to the conditions stipulated in the terms and conditions applicable to the service of the third-party.`,
    },
  ]);
  const [complaints, setComplaints] = useState([
    {
      point:
        "Farmer’s City provides a tool in the Farmer’s City platform, for the benefit of the Customer, for presentation of complaints regarding the Seller and / or Services Provider or the product and / or service provided, acting as mediator in these cases. This service is provided only for the better functioning of the Farmer’s City platform and for a more efficient and faster resolution of disputes arising from the contractual relationship between the Users.",
    },
    {
      point: `To carry out the payment of the products and / or services ordered, the User expressly accepts the terms and conditions of use of the partner payment platform, available at farmerscity.in.`,
    },
    {
      point: `Any Customer complaint should always be addressed to Farmer’s City, through the means available on the Farmer’s City platform, namely to the email  info@farmerscity.in, which shall communicate it to the Seller and / or Services Provider within two (2) days. The Seller and / or Services Provider has a two (2) days term to send Farmer’s City a reply to the complaint presented.`,
    },
    {
      point: `Farmer’s City undertakes to keep the Customer informed about the status of the complaint process.`,
    },
    {
      point: `The Seller and / or Services Provider may, in response to the complaint submitted:
      (i) uphold the complaint filed by the Customer; or (ii) consider that there are no grounds for the complaint
      `,
    },
    {
      point: `If the Seller and / or Services Provider upholds the complaint, there shall be correction of any defects, faults, disabilities or differences in relation to the products and / or services contracted by the Customer, on the account of the Seller and / or Services Provider or, if this is not possible, the price paid for the supply and / or the services provided shall be returned to the Customer in proportion of the breach, inaccuracy, failure or defect in the execution of the service or product delivered.`,
    },
    {
      point: `Users acknowledge that they cannot hold Farmer’s City responsible for the decisions of the Seller and / or Services Provider.`,
    },
    {
      point: `Regardless of the use of this tool to present complaints regarding the Seller and / or Services Provider or the purchased product and / or service provided, the Customer shall always have the right to submit his/her complaint before any competent judicial and extra-judicial mechanisms.`,
    },
  ]);
  const [final, setFinal] = useState([
    {
      point:
        "The User may not assign or transfer these Terms and Conditions, in whole or in part, without the prior written consent of Farmers City.",
    },
    {
      point: `The User authorizes Farmer’s City to assign or transfer these Terms and Conditions, in whole or in part, to: (i) a subsidiary or affiliate; (ii) an acquirer of Farmers’ City s capital or assets; or (iii) any successor.`,
    },
    {
      point: `These Terms and Conditions do not determine the existence of any vertical relationship, partnership, work or agency relationship between the User, Farmer’s City and any third party.`,
    },
    {
      point: `If any provision of these Terms and Conditions is found to be unlawful, invalid or unenforceable, in whole or in part, under any law, such provision or part thereof shall to this extent be understood as not forming part of these Terms and Conditions, and the legality, validity and enforceability of the remaining provisions shall not be affected. In this case, the part of the illegal, invalid or unenforceable provision shall be replaced by a (part of a) provision that is legal, valid and enforceable and that has, to the greatest extent possible, a similar effect to the provision or its illegal, invalid or unenforceable part, taking into account the contents and purpose of these Terms and Conditions.`,
    },
    {
      point: `These Terms and Conditions contain the entire agreement between Farmer’s City and the User. Farmer’s City reserves the right to, at any time, alter these Terms and Conditions in any way. Whenever changes are made to the applicable Terms and Conditions, Users shall be presented, when accessing the Farmer’s City platform, a notice informing them of such fact and a request for acceptance of the new Terms and Conditions. Without this acceptance, Users shall not be able to continue to access and use the Farmer’s City platform. Any notices of modification of these Terms and Conditions shall also be published on the website: farmerscity.in Changes made to the Terms and Conditions shall not be retroactive and shall not take effect within a period of less than fourteen (14) days after their publication. Changes to the Terms and Conditions that result from (i) modifications or new features of the Farmer’s City platform, or (ii) legal impositions, which shall produce immediate effects, are excepted.`,
    },
    {
      point: `The present Terms and Conditions, as well as any dispute inherent to Farmer’s City, shall be subject to the Indian Law and the courts of the State of Haryana are hereby designated as competent.`,
    },
  ]);
  return (
    <div className="py-5">
      <div className="container px-md-5">
        <h2 className="mb-0 ff_heebo fw-bold fs_6xl clr_dark_green">
          TERMS AND CONDITIONS
        </h2>

        <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
          Farmer’s City platform is committed to ensuring the protection of the
          security of personal data that is made available to it and has adopted
          and implemented strict organizational and technical security measures,
          in particular, protecting the channel between the browser and the
          server through a HTTPS certificate in order to protect personal data
          against its unauthorized diffusion, loss, misuse, alteration,
          processing or access, and against any other forms of illicit
          processing.
        </p>
        <p className="ff_heebo clr_dark_grey_2 fs_md mb-0 mt-3">
          By using Farmer’s City, the User is accepting these terms and
          conditions in full and shall be legally bound to said terms and
          conditions, so he/she should read them carefully. Access to and use of
          Farmer’s City depends solely on the acceptance of these Terms and
          Conditions.
        </p>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green">
            1. DEFINITIONS
          </h3>
          <ul className="ps-3 mt-2 policy-ul">
            {definition.map((value, index) => (
              <li key={index} className="d-flex align-items-start gap-2 mt-2">
                <div className="policy-ul-li-dots mt-2"></div>

                <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                  {value.point}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green">
            2. RIGHTS AND LICENSE TO USE
          </h3>
          <ul className="ps-3 mt-2 policy-ul">
            {license.map((value, index) => (
              <li key={index} className="d-flex align-items-start gap-2 mt-2">
                <div className="policy-ul-li-dots mt-2"></div>

                <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                  {value.point}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green">
            3. CONDITIONS OF USE AND OPERATION OF THE FARMER’S CITY PLATFORM
          </h3>
          <div>
            <p className="mb-0 ff_heebo clr_dark_grey_2 fs_md mt-2 fw-semibold">
              What are the conditions of access?
            </p>
            <ul className="ps-3 mt-2 policy-ul">
              {access.map((value, index) => (
                <li key={index} className="d-flex align-items-start gap-2 mt-2">
                  <div className="policy-ul-li-dots mt-2"></div>

                  <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                    {value.point}
                  </p>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-0 ff_heebo clr_dark_grey_2 fs_md mt-2 fw-semibold">
              How does it work?
            </p>
            <ul className="ps-3 mt-2 policy-ul">
              {how.map((value, index) => (
                <li key={index} className="d-flex align-items-start gap-2 mt-2">
                  <div className="policy-ul-li-dots mt-2"></div>

                  <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                    {value.point}
                  </p>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-0 ff_heebo clr_dark_grey_2 fs_md mt-2 fw-semibold">
              What are the conditions of publication of information on the
              products / services?
            </p>
            <ul className="ps-3 mt-2 policy-ul">
              {condition.map((value, index) => (
                <li key={index} className=" mt-2">
                  <div className="d-flex align-items-start gap-2">
                    <div className="policy-ul-li-dots mt-2"></div>
                    <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                      {value.point}
                    </p>
                  </div>
                  <div className="ps-5">
                    <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                      {value.subpointA}
                    </p>
                    <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                      {value.subpointB}
                    </p>
                    <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                      {value.subpointC}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-0 ff_heebo clr_dark_grey_2 fs_md mt-2 fw-semibold">
              What are the conditions of purchasing / services contracting?
            </p>
            <ul className="ps-3 mt-2 policy-ul">
              {contracting.map((value, index) => (
                <li key={index} className="d-flex align-items-start gap-2 mt-2">
                  <div className="policy-ul-li-dots mt-2"></div>
                  <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                    {value.point}
                  </p>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-0 ff_heebo clr_dark_grey_2 fs_md mt-2 fw-semibold">
              What price shall the Customer pay for the products / services?
            </p>
            <ul className="ps-3 mt-2 policy-ul">
              {services.map((value, index) => (
                <li key={index} className="d-flex align-items-start gap-2 mt-2">
                  <div className="policy-ul-li-dots mt-2"></div>
                  <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                    {value.point}
                  </p>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mb-0 ff_heebo clr_dark_grey_2 fs_md mt-2 fw-semibold">
              What is the payment method of the products / services by the
              Customer?
            </p>
            <ul className="ps-3 mt-2 policy-ul">
              {paymentMethod.map((value, index) => (
                <li key={index} className="d-flex align-items-start gap-2 mt-2">
                  <div className="policy-ul-li-dots mt-2"></div>
                  <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                    {value.point}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green">
            2. USER'S OBLIGATIONS
          </h3>
          <ul className="ps-3 mt-2 policy-ul">
            {userObligation.map((value, index) => (
              <li key={index} className="d-flex align-items-start gap-2 mt-2">
                <div className="policy-ul-li-dots mt-2"></div>

                <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                  {value.point}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green">
            3. FARMER’S CITY’s LIABILITY AND LIMITATION OF LIABILITY
          </h3>
          <ul className="ps-3 mt-2 policy-ul">
            {liability.map((value, index) => (
              <li key={index} className="d-flex align-items-start gap-2 mt-2">
                <div className="policy-ul-li-dots mt-2"></div>

                <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                  {value.point}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green">
            4. COMPLAINTS
          </h3>
          <ul className="ps-3 mt-2 policy-ul">
            {complaints.map((value, index) => (
              <li key={index} className="d-flex align-items-start gap-2 mt-2">
                <div className="policy-ul-li-dots mt-2"></div>

                <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                  {value.point}
                </p>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green">
            5. SUSPENSION AND CANCELLATION OF THE ACCOUNT
          </h3>
          <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm mt-2">
            Farmer’s City reserves the right to suspend for any period of time
            it will define, to cancel, at its discretion and whenever it deems
            necessary, to the extent permitted by law, the Account of any User
            who violates or, regarding whom there is suspicion of violation,
            present or future, of any of the obligations under these Terms and
            Conditions and / or the law, namely in case of false information to
            be provided by the User.
          </p>
        </div>
        <div className="mt-4">
          <h3 className="mb-0 ff_heebo fw-bold fs_2xl clr_dark_green">
            6. FINAL PROVISIONS
          </h3>
          <ul className="ps-3 mt-2 policy-ul">
            {final.map((value, index) => (
              <li key={index} className="d-flex align-items-start gap-2 mt-2">
                <div className="policy-ul-li-dots mt-2"></div>

                <p className="mb-0 ff_heebo clr_dark_grey_2 fs_sm">
                  {value.point}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermAndConditions;
